import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { IdentifyNotifier } from './identify-notifier';
import { IdentifyState } from './identify-state';

@Injectable()
export class IdentifyProvider extends BaseProvider<IdentifyNotifier, IdentifyState> {
  constructor() {
    super(IdentifyNotifier);
    this.trackSessionReset(() => this.notifier.resetState());
  }
}
